import SigninContainer from "./SigninContainer"

const Signin = () => {
  return <div className="w-screen h-screen">
    <SigninContainer />
  </div>
}

export default Signin;